<template>
  <div class="modal fade" id="infoProductModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" ref="infoProductModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title text-red" id="myModalLabel" style="font-size: 20px">
            {{currentProduct[schema.product.name]}}
          </h4>
        </div>
        <div class="modal-body">
          <menu-options
            :currentProduct="currentProduct"
            :checkPrice="checkPrice"
            :checkAddProduct="checkAddProduct"
            :checkAddDifProduct="checkAddDifProduct"
            :productAmount="number"
            :ref="'menu-options-' + currentProduct[schema.product.product_id]"
            :pAIndex="1"
            :menuJson="menuJson"
          />
          <ul class="nav">
            <li class="col-xs-12 p-x-0 order-item m-t-15 p-5">
              <p>總金額：{{totalPrice()}} 元</p>
              <div class="q-numeric textfield row inline items-center input-number m-x-0 col-xs-12">
                <div class="input-group">
                    <span class="input-group-addon numeric-left c-pointer bg-pink"  @click="number--">
                      -
                    </span>
                  <input type="tel" pattern="[0-9]*" tabindex="0" step="1" min="1" max="99" class="no-style auto q-input-field inline-block text-center" maxlength="2" v-model="number">
                  <span class="input-group-addon numeric-right  c-pointer bg-pink" @click="number++">
                      +
                    </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">關閉</button>
          <button type="button" class="btn btn-success" @click="clickAdd">測試</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parse from '../../../../assets/js/parse-menu.js'
import menuOptions from './MenuOptions.vue'
import $ from 'jquery'
export default{
  components: {
    'menu-options': menuOptions
  },
  props: {
    modalView: {
      type: Boolean
    },
    currentProduct: {
      type: [Array]
    },
    brandId: {
      type: Number
    },
    menuJson: {
      type: [Object, String]
    }
  },
  data () {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      totalPrice () {
        return parseInt(this.number, 10) * this.price
      },
      combineId: '',
      adjusts: [],
      adjustsIndexMapping: {},
      optionsIndexMapping: {},
      counter: 0,
      limitList: [],
      productCombineIds: [],
      number: 1,
      price: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },
      show: {
        reChoose: false,
        picDetail: false
      },
      swiperOption: {
        autoplay: 4000,
        setWrapperSize: true,
        pagination: '.img-pagination',
        paginationClickable: true,
        // mousewheelControl: true,
        observeParents: true,
        prevButton: '.img-button-prev',
        nextButton: '.img-button-next',
        loop: true,
        paginationElement: 'li'
      },
      // 商品加料金額與內容
      addPrice: {},
      addDetail: {},
      // option 條列式
      optionStyle: false
    }
  },
  methods: {
    clickAdd () {
      var pSchema = this.schema.product
      if (this.$refs['menu-options-' + this.currentProduct[pSchema.product_id]].clickAdd()) this.addProduct()
    },
    addProduct () {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      // const cSchema = this.schema.combine
      // const eSchema = this.schema.edge

      // Data
      var products = {
        /*
        items: [
          {
            product_id: this.currentProduct[pSchema.product_id],
            type: 1,
            amount: this.number,
            combine_id: this.combineId,currentProduct
            options: [],
            adjusts: []
          }
        ]
        */
        items: this.addDetail[this.currentProduct[pSchema.product_id]].items
      }
      // console.log(this.currentProduct)
      // products.items[0].additional_products.push()
      // 需增加是否有選擇修飾條件的判斷
      // ajax call 可以在vuex action中載入
      for (var adjust of this.adjusts) {
        if (adjust.activeCount > 0) {
          var adjustP = {
            adjust_id: parseInt(adjust[aSchema.product_id], 10),
            options: []
          }
          for (var option of adjust[aSchema.option_list]) {
            if (option.activeCount > 0) {
              adjustP.options.push({option_id: parseInt(option[oSchema.product_id], 10), amount: 1})
            }
          }
          products.items[0].adjusts.push(adjustP)
        }
      }
      this.$notify({
        title: '成功',
        text: '成功加入商品',
        duration: 2500,
        type: 'success'
      })
    },
    adjustsOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list]
    },
    optionsOfAdjust (adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list]
    },
    combinesOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.combine_list]
    },
    getProduct (productId) {
      return this.menu.productList[productId]
    },
    getAdjust (adjustId) {
      return this.menu.adjustList[adjustId]
    },
    getOption (optionId) {
      return this.menu.optionList[optionId]
    },
    getCombine (combineId) {
      return this.menu.combineList[combineId]
    },
    showOption (aIndex, isMandatory) {
      var self = this
      if (typeof isMandatory === 'undefined' || isMandatory) {
        $('.options-' + aIndex).slideToggle(function () {
          var visible = $(this).is(':visible')
          if (visible) self.isVisible.push(aIndex)
          else self.removeArray(self.isVisible, aIndex)
        })
      }
    },
    parsePrice (product) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      var productId = product[pSchema.product_id]
      var price
      var type
      var checkP = this.getProduct(productId)
      var checkA = this.getAdjust(productId)
      var checkO = this.getOption(productId)
      var isOption = []
      var minPrice = []
      if (checkP) {
        // console.log(checkP)
        price = checkP[pSchema.price]
        type = 'p'
        var aList = checkP[pSchema.adjust_list]
        aList = parse.divideList(aList, this.getAdjust)
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = []
          var tag = 0
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price])
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice))
          }
        }
        for (var m = 0; m < aList.length; m++) {
          // var min = aList[j][aSchema.min_limit]
          var max = aList[m][aSchema.max_limit]
          var tags = 1
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++
              if (aList[m][aSchema.is_mandatory]) isOption.push({adjust: aList[m], option: aList[m][aSchema.option_list][n]})
            }
          }
        }
        // console.log(isOption)
      } else if (checkA) {
        // console.log(checkA)
        price = checkA[aSchema.price]
        type = 'a'
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price]
            }
          }
        }
      } else if (checkO) {
        // console.log(checkO)
        price = checkO[oSchema.price]
        type = 'o'
      }
      if (isOption.length) this.isOption = isOption
      return {price: price, type: type}
    },
    showAll (product, combines) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var adjustIds = product[pSchema.adjust_list]
      var result = []

      // Fill Up adjust.option_list with option
      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = parse.divideList(adjustIds, this.getAdjust)[adjustIndex]
        if (adjust) {
          adjust.activeCount = 0
          adjust.activeOptionIds = []
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex])
              adjust[aSchema.option_list][optionIndex].activeCount = 0
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1
            }

            return 0
          })
          result.push(adjust)
        }
      }
      // 排adjust順序 (尺寸, 溫度, 甜度, 加料)
      result.push([])
      result.sort(function (a, b) {
        return b[aSchema.sub_type] - a[aSchema.sub_type]
      })
      result.splice(-1, 1)
      var result2 = result
      // 尺寸 順序對調
      // 尺寸
      var sizeIndex = result.findIndex(function (adjust) { return adjust[aSchema.sub_type] === 10 })
      var size = result.find(function (adjust) { return adjust[aSchema.sub_type] === 10 })
      if (sizeIndex > -1) {
        result2.splice(sizeIndex, 1)
        result2.splice(0, 0, size)
      }
      return result2
    },
    filterCombine (combines) {
      //  Schema
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge
      const aSchema = this.schema.adjust
      this.isShow = []

      // filter combination
      $('.btn-option').css('display', 'none')
      var combine = parse.divideList(combines, this.getCombine)
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id])
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index
      })
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id]
        if (this.getOption(num)) {
          // show
          $('#option-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block')
        } else if (this.getAdjust(num)) {
          // show
          var options = this.getAdjust(num)[aSchema.option_list]
          for (var o = 0; o < options.length; o++) {
            $('#option-' + options[o][oSchema.product_id]).css('display', 'inline-block')
          }
        }
      }
    },
    createMapping (arrayData, idIndex) {
      var mapping = {}
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i
      }

      return mapping
    },
    createOptionMapping (adjusts) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var mapping = {}
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          }
        }
      }

      return mapping
    },
    search (id, adjusts, productId) {
      var result = []
      var aSchema = this.schema.adjust
      // var product = this.getProduct(id)
      var adjust = this.getAdjust(id)
      var option = this.getOption(id)
      if (option) {
        result.push(option)
        return result
        // if edge is option
      } else {
        if (adjust) {
          // result.push(adjust)
          option = parse.divideList(adjust[aSchema.option_list], this.getOption)
          for (var i = 0; i < option.length; i++) {
            result.push(option[i])
          }

          /*
          result[1].sort(function (a, b) {
            return b[7] - a[7]
          })
          */
          return result
        }
        /*
        else {
          if (product) {
            // if edge product
            result.push(product)
            return result
          }
        }
        */
      }
      /*
      for (var i = 0; i < adjusts.length; i++) {
        if (id === adjusts[i]) {
          result.push(id)
        }
      }
      */
    },
    clickOption (clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      // const cSchema = this.schema.combine

      // Disable Animation
      $('#option-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave')

      // Data
      // 0.
      var clickedAdjustId = clickedAdjust[aSchema.product_id]
      var clickedOptionId = clickedOption[oSchema.product_id]
      var productAdjustIds = this.currentProduct[pSchema.adjust_list]
      // var productCombineIds = this.currentProduct[pSchema.combine_list]
      var adjustIndex = 0
      var adjust = null
      // var optionIndex = 0
      var option = null
      var blockedOptionIds = []
      var bOptionId

      // Add All mandatory Class on Click
      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex])
        if (adjust[aSchema.is_mandatory] === true) {
          $('.adjust-' + productAdjustIds[adjustIndex]).addClass('mandatory')
        }
      }

      // Click Flow
      // 1. 假如是取消點選(此處定義為取消點選全部，亦即該 Option 有同樣的三份，就是這三個都取消)
      if ($('#option-' + clickedOptionId).attr('active')) {
        this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId)
        clickedAdjust.activeCount -= clickedOption.activeCount
        clickedOption.activeCount = 0
        $('#option-' + clickedOptionId).removeAttr('active', false)
        $('#option-' + clickedOptionId).removeClass('active')
        for (adjust of this.adjusts) {
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }

        var passCombinations = this.ruleValidation()
        blockedOptionIds = this.getBlockedOptionIds(passCombinations)
        for (bOptionId of blockedOptionIds) {
          $('#option-' + bOptionId).addClass('btn-blocked')
        }
        this.price = this.calculatePriceBySelectedOptions(passCombinations)

        return
      }

      // 2. 選取並檢查是否超過此 Option 上限
      clickedAdjust.activeOptionIds.push(clickedOptionId)
      clickedAdjust.activeCount++
      clickedOption.activeCount++
      $('#option-' + clickedOptionId).attr('active', true)
      // if(clickedOption.activeCount > clickedOption[aSchema.max_limit]) {
      //   Toast.create.negative({
      //     html: '此選項最多只能加' + clickedOption[oSchema.max_limit] + '份喔！',
      //     timeout: 2500
      //   })
      // }

      // 3. 如果規則驗證失敗就全部重來
      passCombinations = this.ruleValidation()
      if (passCombinations.length === 0) {
        // Remove
        for (adjust of this.adjusts) {
          adjust.activeOptionIds = []
          adjust.activeCount = 0
          for (option of adjust[aSchema.option_list]) {
            option.activeCount = 0
          }
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeAttr('active')
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('active')
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = 1
        clickedOption.activeCount = 1
        $('#option-' + clickedOptionId).attr('active', true)
      }

      // 4. 超過這個 Adjust 上限，這個 Adjust 全部重來
      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        // Remove
        clickedAdjust.activeOptionIds = []
        clickedAdjust.activeCount = 0
        for (option of clickedAdjust[aSchema.option_list]) {
          option.activeCount = 0
        }
        $('.adjust-' + clickedAdjustId + ' div').removeAttr('active')
        $('.adjust-' + clickedAdjustId + ' div').removeClass('active')
        for (adjust of this.adjusts) {
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = 1
        clickedOption.activeCount = 1
        $('#option-' + clickedOptionId).attr('active', true)

        // Toast.create.negative({
        //   html: clickedAdjust[aSchema.name] + '只能選 ' + clickedAdjust[aSchema.max_limit] + ' 種喔！',
        //   timeout: 2500
        // })
      }

      // 5.
      passCombinations = this.ruleValidation()
      blockedOptionIds = this.getBlockedOptionIds(passCombinations)
      for (bOptionId of blockedOptionIds) {
        $('#option-' + bOptionId).addClass('btn-blocked')
      }
      this.price = this.calculatePriceBySelectedOptions(passCombinations)
    },
    // 規則驗證
    ruleValidation () {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var constrainCombList = []
      var adjust = null
      var option = null
      var combineId = null
      var combine = null
      var edge = null
      var isExist = false
      // 把 combination 分開來檢查
      for (combineId of this.productCombineIds) {
        combine = this.menu.combineList[combineId]
        // 掃描所有已經選取的 Options，看看是不是全部都在這個 combination 下
        var allInGraph = true
        for (adjust of this.adjusts) {
          for (option of adjust[aSchema.option_list]) {
            if (option.activeCount > 0) {
              //
              isExist = false
              for (var edgeId in combine[cSchema.edge_list]) {
                edge = combine[cSchema.edge_list][edgeId]
                switch (edge[eSchema.product_type]) {
                  // Option = 2
                  case 2:
                    if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                      isExist = true
                    }
                    break
                  // Adjust = 20
                  case 20:
                    if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                      isExist = true
                    }
                    break
                }
                if (isExist) {
                  break
                }
              }
              if (!isExist) {
                allInGraph = false
                break
              }
            }
          }
          if (!allInGraph) {
            break
          }
        }
        if (allInGraph) {
          constrainCombList.push(combine)
        }
      }

      return constrainCombList
    },
    // 取得禁選的 Option IDs
    getBlockedOptionIds (constrainCombList) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var blockedOptionIds = []
      var adjust = null
      var option = null
      var combine = null
      var edge = null
      var edgeId = null
      var isExist = false

      // 找出不在 constrainCombList 中的 Options
      for (adjust of this.adjusts) {
        for (option of adjust[aSchema.option_list]) {
          //
          isExist = false
          for (combine of constrainCombList) {
            for (edgeId in combine[cSchema.edge_list]) {
              edge = combine[cSchema.edge_list][edgeId]
              switch (edge[eSchema.product_type]) {
                // Option = 2
                case 2:
                  if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                    isExist = true
                  }
                  break
                // Adjust = 20
                case 20:
                  if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                    isExist = true
                  }
                  break
              }
              if (isExist) {
                break
              }
            }
            if (isExist) {
              break
            }
          }
          if (!isExist) {
            blockedOptionIds.push(option[oSchema.product_id])
          }
        }
      }

      return blockedOptionIds
    },
    calculatePriceBySelectedOptions (constrainCombList) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // Data
      var minPrice = 0
      var maxCombineId = 0
      var maxPrice = 0
      var adjustIndex = null
      var adjust = null
      var optionMapping = null
      var option = null

      // Logic
      for (var combine of constrainCombList) {
        var price = 0
        if (combine[cSchema.price] !== null) {
          price = combine[cSchema.price]
          if (price < minPrice) {
            minPrice = price
          }
          if (price > maxPrice) {
            maxPrice = price
            maxCombineId = combine[cSchema.combine_id]
          }
          continue
        }
        for (var edgeId in combine[cSchema.edge_list]) {
          var edge = combine[cSchema.edge_list][edgeId]
          switch (edge[eSchema.product_type]) {
            // Product = 1
            case 1:
              price += this.getProduct(edge[eSchema.product_id])[pSchema.price]
              break
            // Option = 2
            case 2:
              optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]]
              option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex]
              if (option.activeCount > 0) {
                if (edge[eSchema.price] === null) {
                  price += (Number(option[oSchema.price]) * option.activeCount)
                } else {
                  price += (edge[eSchema.price] * option.activeCount)
                }
              }
              break
            // Adjust = 20
            case 20:
              // 這個 case 要考慮三件事情，「edge」、「adjust」、「option 的加總」
              adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]]
              adjust = this.adjusts[adjustIndex]
              var isActiveAdjust = false
              var adjustPrice = 0
              for (option of adjust[aSchema.option_list]) {
                if (option.activeCount > 0) {
                  isActiveAdjust = true
                  adjustPrice += (option[oSchema.price] * option.activeCount)
                }
              }
              if (isActiveAdjust) {
                if (edge[eSchema.price] !== null) {
                  price += edge[eSchema.price]
                } else if (adjust[aSchema.price] !== null) {
                  price += adjust[aSchema.price]
                } else {
                  price += adjustPrice
                }
              }
              break
          }
        }
        if (price < minPrice) {
          minPrice = price
        }
        if (price > maxPrice) {
          maxPrice = price
          maxCombineId = combine[cSchema.combine_id]
        }
      } // end_of_constrainCombList

      this.combineId = maxCombineId
      return maxPrice
    },
    getSessionName (type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion'
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu'
      } else {
        return false
      }
    },
    removeArray (arr, value) {
      var index = arr.indexOf(value)
      if (index > -1) {
        arr.splice(index, 1)
      }
    },
    checkPrice (price, product) {
      var pSchema = this.schema.product
      this.addPrice[product[pSchema.product_id]] = price
      var newPrice = this.currentProduct[pSchema.price]
      for (var key in this.addPrice) {
        // 商品直接顯示新的價格
        // console.log(this.addPrice)
        newPrice = this.addPrice[key]
      }
      this.price = newPrice
    },
    checkAddProduct (item) {
      this.addDetail[item.items[0].product_id] = item
    },
    checkAddDifProduct (item, pIndex) {
      // this.addDetail[item.items[0].product_id] = item
    },
    init () {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson
        this.menu.categoryList = this.currentMenuJson.category_list_json.data
        this.menu.productList = this.currentMenuJson.product_list_json.data
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data
        this.menu.optionList = this.currentMenuJson.option_list_json.data
        this.menu.combineList = this.currentMenuJson.combine_list_json.data

        this.schema.category = this.currentMenuJson.category_list_json.schema
        this.schema.product = this.currentMenuJson.product_list_json.schema
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema
        this.schema.img = this.currentMenuJson.product_list_json.img_schema
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema
        this.schema.option = this.currentMenuJson.option_list_json.schema
        this.schema.combine = this.currentMenuJson.combine_list_json.schema
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema
        this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema
      }
      this.initOptions()
    },
    clearOption () {
      // Schema
      const aSchema = this.schema.adjust
      var pSchema = this.schema.product

      // Clear Tmp Data
      this.limitList = {}
      for (var adjust of this.adjusts) {
        adjust.activeOptionIds = []
        adjust.activeCount = 0
        for (var option of adjust[aSchema.option_list]) {
          option.activeCount = 0
        }
      }

      this.number = 1
      // this.setBtnDis(false)
      this.price = this.currentProduct[pSchema.price]
    },
    initOptions () {
      var pSchema = this.schema.product
      var cSchema = this.schema.combine
      // this.setBtnDis(false)
      // this.parsePrice(this.currentProduct[0])
      // this.price = this.minPrice
      this.price = this.currentProduct[pSchema.price]
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id]
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds)
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id)
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts)
      this.clearOption()
      // 加料金額與內容
      this.addPrice = {}
      this.addDetail = {}
      this.addAdjust = {}
      // 查看option選擇後價格
      this.optionCheck = 0
      this.$nextTick(function () {
        // this.filterCombine(this.productCombineIds)
        // this.orderInfo.menuId = window.sessionStorage[config.menuId]
        // show default option
        /*
        for (var j = 0; j < this.isOption.length; j++) {
          var option = this.isOption[j].option
          var adjust = this.isOption[j].adjust
          self.clickOption(option, 0, adjust, 0)
        }
        */
      })
    },
    checkAdjustDis (aId) {
      // console.log(this.disAdjust)
      // console.log(aId)
      var dis = this.disAdjust.find(function (o) { return o === aId })
      if (dis) {
        return false
      } else return true
    },
    checkOptionDis (oId, aId) {
      // console.log(this.disOption)
      // console.log(oId, aId)
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) { return o.product_id === oId })
        if (dis) {
          return false
        } else return true
      } else {
        return true
      }
    },
    getSubImages (pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].sub_image_list
      return []
    }
  },
  ready () {
  },
  computed: {
    cheeseWording () {
      var name = this.currentProduct[this.schema.product.name]
      if (name) name = name.trim()
      switch (name) {
        case '日式燒肉堡':
        case '雙層起司雞腿堡':
        case '法式紅酒牛肉堡':
        case '墨西哥辣椒豬肉堡':
        case '墨西哥辣椒牛肉堡':
        case '豬肉起司瑪芬堡':
        case '豬肉瑪芬堡加蛋':
        case '雙層豬肉瑪芬堡':
        case '雙層豬肉瑪芬堡加蛋':
        case '義式磚壓-薑汁燒肉':
        case '口袋歐姆蛋-起士歐姆蛋':
        case '口袋歐姆蛋-肉醬歐姆蛋':
        case '口袋歐姆蛋-培根歐姆蛋':
        case '口袋歐姆蛋-蔬菜歐姆蛋':
        case '口袋歐姆蛋-鮪魚歐姆蛋':
        case '磚壓-法式紅酒牛肉':
        case '磚壓-墨西哥辣椒豬肉':
        case '磚壓-墨西哥辣椒牛肉':
          return true
        default: return false
      }
    },
    showLgImg () {
      var layout = this.layout
      switch (layout) {
        case 1: return false
        case 2: return true
        case 3: return true
        case 4: return false
        default: return false
      }
    },
    storeStateName () {
      var state = this.storeState
      if (state === 0) return '門市未營業'
      else if (state === 1) return '門市籌備中'
      else if (state === 3) return '門市休息中'
      else if (state === 9) return '門市已歇業'
    },
    minCombinePrice () {
      var oSchema = this.schema.option
      var price = 0
      // 如果combine沒有價格，此為最小的combine組合價格
      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price]
      }
      return price
    },
    combinePrice () {
      var minPrice
      var self = this
      var priceCombine = []
      var priceList = []
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price]
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list]
            for (var key in edgeList) {
              this.parsePrice(edgeList[key])
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price
            }
            // combine 無價格 (price 已經為最低的組合價格，非該combine的價格)
            item = {price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          } else {
            // combine 有價格
            item = {price: price, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          }
        }
      }
      // 如果combine有的有價格，有的沒有在此比較
      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price)
      }
      minPrice = Math.min.apply(Math, priceList)
      return minPrice
    },
    isBigMilk () {
      var pSchema = this.schema.product
      var product = this.currentProduct
      var productName = product[pSchema.name]
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true
      }
      return false
    }
  },
  mounted () {
    $('.q-numeric input').attr('maxlength', '2')
    $('.q-numeric input').attr('type', 'tel')
    $('.q-numeric input').keyup(function () {
      var e = $('.q-numeric input')
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    })
    // $('.q-numeric input').attr('disabled', true).css('-webkit-text-fill-color', '#333')
  },
  watch: {
    currentProduct: {
      handler () {
        this.init()
      },
      deep: true
    },
    cartMount () {
      this.setCartAmount(this.cartMount)
    },
    number () {
      if (!this.number) this.number = 1
    }
  }
}
</script>

<style lang="sass" scoped>
  $default-color: #00a8e8
  .order-item
    margin-bottom: 10px
  .q-numeric .input-group
    width: 105px !important
    padding: 4px 0px
    color: $default-color
  .numeric-left, .numeric-right, .q-numeric input
    border: solid 1px $default-color !important
    height: 28px !important
    padding: 3px 12px !important
  .numeric-left
    border-right: 0 !important
  .numeric-right
    border-left: 0 !important
  .q-numeric input
    width: 50px !important
  .btn-option:hover, .btn-option:focus, .btn-option:focus:active, .btn-option:active, .btn-option:hover:active
    background: #fff
    border: solid 1px $default-color
    color: #444
  .btn-option
    width: calc(100% / 3 - 10px)
    border-radius: 5px
    border: solid 1px $default-color
    margin: 5px
    background: #fff
  @media screen and (max-width: 444px)
    .btn-option
      width: calc(50% - 10px)
  @media screen and (max-width: 299px)
    .btn-option
      width: calc(100% - 10px)
  .q-numeric input
    border-radius: 0px
    -webkit-appearance: none
  #btn-update-cart
    width: calc(100% - 15px)
    padding-right: 10px
    padding-left: 10px
    max-width: 100%
    height: 61px
  .i-dropdown
    padding-left: 5px
    padding-right: 5px
    cursor: pointer
  .btn-blocked
    background-color: #fff !important
    color: #8E8E93 !important
    border: 1px solid #8E8E93 !important
  .btn-option
    line-height: 20px
  .no-style.q-input-field
    color: #333
  .btn-order-list
    text-align: center
  .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled]
    background-color: #fff !important
    color: #8E8E93 !important
    border: 1px solid #8E8E93 !important
    cursor: default !important
    pointer-events: none !important
  .adjust .btn-default[active], .adjust .btn-default.active
    background: #e1456d !important
    color: #fff !important
    border: 1px solid #e1456d !important
    box-shadow: none !important
  .modal-buttons.row
    margin-left: 0px !important
    margin-right: 0px !important
  .modal-header
    border-bottom: 0px
  @media (min-width: 601px)
    .btn-option
      width: calc(25% - 10px)
    .col-xs-6.btn-update-cart
      width: 100% !important
    @-moz-document url-prefix()
      .menu-model .modal-content div button:last-child, .menu-model .modal-content div button:last-child
        margin-bottom: 30px
  @media (max-width: 600px)
    @-moz-document url-prefix()
      .fixed-moz-b-150
        padding-bottom: 150px
</style>
<style lang="sass">
  .input-group-addon.bg-pink
    background: #00a8e8 !important
  .m-t-15
    margin-top: 15px !important
</style>



// WEBPACK FOOTER //
// MenuModalNew.vue?3e8e1e4c